import React from 'react';
import { Content, Pane, Text } from '@leverege/ui-elements';
import { Attributes } from '@leverege/ui-attributes';
import { Config } from '@leverege/plugin';
import I18N from '@leverege/i18n';
import { GroupDelegate } from '@leverege/molten-core';
import AbstractGroupScreen, { connectChild } from "../group/AbstractGroupScreen.js";
import { dvProps } from "../../dataViewers/Util.js";
import ResponsiveGroupScreen from "../group/GroupScreen.js";
import { FilterSourcesModel } from "../../filters/index.js";
import SearchBar from "../group/search/SearchBar.js";
import { Util } from "../../routes/index.js";
import useResponsiveBreakpoints from "../../views/hooks/UseResponsiveBreakpoints.js";
import S from './DesktopSimpleSearchScreen.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  t
} = I18N.ns('molten.screens.simpleSearch');
class DesktopSimpleSearchScreen extends AbstractGroupScreen {
  constructor(props) {
    super(props);
    this.state = {
      doctoredActions: this.createDoctoredActions()
    };
  }
  componentDidMount(props) {
    super.componentDidMount(props);
    const {
      setIcon,
      setTitle,
      setActionsMatchContext,
      setActionsContext
    } = this.props;
    if (setIcon) setIcon({
      data: this.getIcon()
    });
    if (!setIcon && setTitle) {
      setTitle({
        data: /*#__PURE__*/_jsx(Text, {
          variant: "mobileScreenTitle|screenTitle",
          icon: this.getIcon(),
          children: this.getTitle()
        })
      });
    } else if (setTitle) {
      setTitle({
        data: this.getTitle()
      });
    }
    if (setActionsContext) {
      setActionsContext({
        data: null
      });
    }
    if (setActionsMatchContext) {
      setActionsMatchContext({
        data: null
      });
    }
  }
  componentDidUpdate(prevProps) {
    const {
      delegate: pDelegate
    } = prevProps;
    const {
      delegate
    } = this.props;
    if (pDelegate !== delegate) {
      this.setDoctoredActions();
    }
  }
  shouldLoadData() {
    const {
      filters
    } = this.getQueryOptions();
    const search = FilterSourcesModel.getSource(filters, 'freeTextSearch');
    return search?.metadata?.value != null;
  }
  createDoctoredActions() {
    const {
      delegate,
      relationship,
      match
    } = this.props;
    const toReturn = new GroupDelegate({
      match: delegate.match,
      relationship: delegate.relationship,
      ...delegate.options
    });
    const original = toReturn.getUrl.bind(toReturn);
    toReturn.getUrl = function getUrl(forInterfaceUrl = false) {
      if (!forInterfaceUrl) {
        return Util.resolve(relationship.urlPath, match);
      }
      return original(forInterfaceUrl);
    };
    return toReturn;
  }
  setDoctoredActions() {
    const doctoredActions = this.createDoctoredActions();
    this.setState({
      doctoredActions
    });
  }
  getDoctoredActions() {
    const {
      delegate
    } = this.state;
    return delegate;
  }
  render() {
    const {
      settingsPath,
      relationship,
      parentItem,
      doodle,
      hint,
      hintIcon,
      areaVariant = 'simpleSearchArea',
      areaLayout = 'flex:col',
      contentLayout = 'flex:simpleSearchContent|colL',
      contentVariant = 'simpleSearchContent',
      captionVariant = 'simpleSearchCaption|caption'
      // returnToLanding = false
    } = this.props;
    const {
      doctoredActions
    } = this.state;
    let nHint;
    if (relationship.parentBlueprint) {
      const {
        parentBlueprint
      } = relationship;
      const parentName = Attributes.get(parentBlueprint.nameAttribute || 'name', parentItem.type, parentItem.data) || `a ${parentBlueprint.name}`;
      nHint = hint || t('groupHint', {
        parentName,
        name: relationship.attribute.name
      });
    } else {
      nHint = hint || t('hint', {
        name: relationship.blueprint.namePlural
      });
    }
    // const mainVertical = layout[1] === 'v'
    const {
      filters
    } = this.getQueryOptions();

    // eslint-disable-next-line object-property-newline
    const common = this.getDataViewerProps(null, false);
    const search = FilterSourcesModel.getSource(filters, 'freeTextSearch');
    if (search?.metadata?.value) {
      this.hadSearch = true;
    }
    // Old check looks like this
    // if ( !search?.metadata?.value && !( this.hadSearch || returnToLanding ) )

    if (!search?.metadata?.value) {
      return /*#__PURE__*/_jsx(Content, {
        children: /*#__PURE__*/_jsx(Content.Area, {
          variant: areaVariant,
          layout: areaLayout,
          className: S.area,
          children: /*#__PURE__*/_jsxs(Pane, {
            variant: contentVariant,
            layout: contentLayout,
            className: S.search,
            children: [/*#__PURE__*/_jsx("img", {
              alt: t('alt'),
              width: "100%",
              src: doodle || Config.get('simpleSearch', 'doodle', 'https://storage.googleapis.com/molten-ui-assets/simple-search-doodle.svg')
            }), /*#__PURE__*/_jsx(SearchBar, {
              ...dvProps({
                type: 'freeTextSearch'
              }, common, {
                settingsPath,
                filters
              }),
              focusOnMount: true
            }), /*#__PURE__*/_jsx(Text, {
              icon: hintIcon || Config.get('simpleSearch', 'hintIcon'),
              variant: captionVariant,
              children: nHint
            })]
          })
        })
      });
    }
    return /*#__PURE__*/_jsx(ResponsiveGroupScreen, {
      overrideClientType: true,
      ...this.props,
      delegate: doctoredActions
    });
  }
}
const components = {
  small: props => /*#__PURE__*/_jsx(DesktopSimpleSearchScreen, {
    ...props,
    clientType: "MobileSimpleSearchScreen"
  }),
  big: props => /*#__PURE__*/_jsx(DesktopSimpleSearchScreen, {
    ...props,
    clientType: "DesktopSimpleSearchScreen"
  })
};
function DesktopSimpleSearchScreenWrapper(props) {
  return useResponsiveBreakpoints(components, props);
}
export default connectChild(DesktopSimpleSearchScreenWrapper, {});